import {RouteComponentProps, withRouter} from 'react-router-dom';
import * as React from 'react';
import {connect} from "react-redux";
import {URL} from '../../Config/appConfig';
import {ResetPassword} from '../../Config/dataModel';
import authDispatch from '../../ReduxRequests/Dispatch/authDispatch';
import authState from '../../ReduxRequests/State/authState';
import {assertAllTrue, clearErrors} from '../../Util/errorUtil';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import util from '../../Util/util';
import Footer from '../Footer/Footer';
import '../../style/login.css';

const logo = require('../../resource/img/logo.svg');
const btnSpinner = require('../../resource/img/button-loading.gif');

interface SetOrResetPasswordProps {
    title: string,
    resetPassword: (data: ResetPassword) => void,
    resetPasswordState: () => boolean,
    auth: () => void
}

interface SetOrResetPasswordState {
    password: string,
    confirmPassword: string,
    token: string,
    loading: boolean
}

class SetOrResetPassword extends React.Component <RouteComponentProps & SetOrResetPasswordProps, SetOrResetPasswordState> {
    public constructor(props: SetOrResetPasswordProps) {
        super(props);
        this.state = {
            password: '',
            confirmPassword: '',
            token: '',
            loading: false
        };
        this.goToLogin = this.goToLogin.bind(this);
        this.changePassword = this.changePassword.bind(this);
        this.clickBack = this.clickBack.bind(this);
        this.clickSubmit = this.clickSubmit.bind(this);
        this.onError = this.onError.bind(this);
    }

    public componentWillMount() {
        this.setState({token: this.props.history.location.pathname.split('/')[3]});
    }

    public componentWillReceiveProps(nextProps: SetOrResetPasswordProps) {
        if (nextProps.resetPasswordState()) {
            this.props.history.push(URL.LOGIN);
        }
    }

    public goToLogin(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.props.history.push(URL.LOGIN);
    }

    public changePassword(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        const target = event.target;
        this.setState({
            ...this.state,
            [target.name]: target.value
        });
    }

    public clickBack(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.props.history.push(URL.LOGIN);
    }

    public clickSubmit(event: React.MouseEvent<HTMLElement> | React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        clearErrors();
        const nonBlank = assertAllTrue([
            {code: 161, hasResult: util.isPasswordStrong(this.state.password)},
            {code: 164, hasResult: (this.state.password === this.state.confirmPassword)}
        ]);
        if (!nonBlank) return;
        this.setState({loading: true});
        const data = {
            password: this.state.password,
            token: this.state.token
        };
        this.props.resetPassword(data);
    }

    public onError() {
        this.setState({loading: false});
    }

    public render() {
        return (
            <div>
                <div className="authContainer">
                    <div className="cmCenter loginContainer">
                        <button className="cmHorCenter" onClick={this.goToLogin}>
                            <img src={logo}/>
                        </button>
                        <div className="cmText loginLabel">{this.props.title}</div>
                        <form onSubmit={this.clickSubmit}>
                            <div className="loginArea">
                                <input className="cmLabel cmText cmInput loginInput" type="password"
                                    placeholder="New Password" name="password"
                                    value={this.state.password} onChange={this.changePassword}/>
                                <input className="cmLabel cmText cmInput loginInput" type="password"
                                    placeholder="Confirm Password" name="confirmPassword"
                                    value={this.state.confirmPassword} onChange={this.changePassword}/>
                            </div>
                            <ErrorHandler onError={this.onError}/>
                            <div className="cmBtnsContainer">
                                <div className="cmBtnWrapper">
                                    <button type="button" className="cmBtn cmGreyBtn cmBoldText"
                                            disabled={this.state.loading} onClick={this.clickBack}>
                                        Cancel
                                    </button>
                                </div>
                                <div className="cmBtnWrapper">
                                    <button className="cmBtn cmBlueBtn cmBoldText" onClick={this.clickSubmit}
                                            disabled={this.state.loading}>
                                        <span className="cmBtnWithSpinner">Submit</span>
                                        {this.state.loading && <img className="cmBtnSpinner" src={btnSpinner}/>}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="authFooter"><Footer/></div>
            </div>
        );
    }
}

export default withRouter(connect(authState, authDispatch)(SetOrResetPassword));



// WEBPACK FOOTER //
// ./src/Components/Auth/SetOrResetPassword.tsx